import { getFullUrl } from 'hubspot-url-utils';
import { prefetchPage } from 'prefetcher/utils/prefetchPage';
import { ExperimentIdentifier } from '../experiments/ExperimentIdentifier';
import { setHublet, setIsNewUser, setNewPortalCreated } from '../store/app/action-creators';
import { fetchExperiments } from '../store/experiments/action-creators';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { Step } from 'signup-constants/Step';
import { setNewPortalId } from './setNewPortalId';
import { signupSuccessTracking } from './signupSuccessTracking';
export const handleSignupSuccess = (response, dispatch, getState) => {
  const state = getState();
  const {
    hubId,
    userCreated,
    region: hublet,
    creatorId
  } = response;
  const postAccountCreation = getPostAccountCreationSteps(state);
  signupSuccessTracking(state, creatorId);
  setNewPortalId({
    hubId,
    hublet
  }, dispatch);
  dispatch(setHublet(hublet));
  dispatch(setNewPortalCreated());
  dispatch(setIsNewUser(userCreated));
  if (postAccountCreation.length >= 1 && postAccountCreation[0] !== Step.MobileAppPrompt) {
    dispatch(fetchExperiments({
      identifierPhase: ExperimentIdentifier.PortalId
    }));
  }
  prefetchPage('setup-guide-ui-prefetch', {
    url: getFullUrl('app', {
      hubletOverride: hublet
    })
  });
};